import { FaArrowRight } from "react-icons/fa6"
import { Link } from "react-router-dom"
import { useSelector } from 'react-redux';
import { DecodeHtml } from './../../utils/decodeHtml';

const Academics = () => {



    const state = useSelector(state => state.aboutUnitenContent)



    const aboutUniten = state?.data?.properties

    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })
    const listTileButtonWithPagePath = aboutUniten?.listTileButtonWithPagePath?.items?.map((item) => {
        return {
            title: item?.content?.properties?.title,
            pagePath: item?.content?.properties?.pagePath?.route?.path.replace("/all-programmes/", "").replace("/", "")
        }
    }) || []



    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            <p className='w-auto whitespace-pre-line'>{description}</p>

            <Link to={"/all-programmes"} className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                <span className="text-white text-base font-bold capitalize flex items-center gap-3">Explore <FaArrowRight /></span>
            </Link>

            <div className="flex flex-col gap-5">
                <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{`Explore Colleges`}</h1>
                <div className="flex flex-col border">
                    {
                        listTileButtonWithPagePath?.map((college, index) => (
                            <div key={index} className="border-b grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 p-5 py-8">
                                <h2 className="w-auto  text-3xl font-bold text-slate-900  leading-tight">{college?.title}</h2>
                                <Link to={`/college/${college?.pagePath}`} className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                                    <span className="text-white text-base font-bold capitalize flex items-center gap-3">See more <FaArrowRight /></span>
                                </Link>
                            </div>
                        ))
                    }

                </div>

            </div>
        </div>
    )
}

export default Academics